import { Tabs, TabsContent, TabsList, TabsTrigger } from '@design-system';
import {
  EmailTab,
  LinkTab,
  FillIntakeFormTab,
  useInviteClientTrigger,
  type TabType,
} from '@/features/invite-client';
import { useFeatureFlags } from '@/contexts/FeatureFlagsContext';
import { EdjPilotRestricted } from '@/shared/components/edj-pilot-restricted';
import { useIsEdjPilotAdvisor } from '@/shared/hooks/use-edj-pilot-advisor';

import { ClipboardPen, Link2, Mail } from 'lucide-react';

export function InviteClientTabs() {
  const { flags } = useFeatureFlags();
  const { inviteClientTab, setInviteClientTab } = useInviteClientTrigger();
  const isEdjPilot = useIsEdjPilotAdvisor();

  const hideEmailAndFillIntakeForm = flags?.hideInviteEmailAndFillIntakeForm;
  const defaultTab = isEdjPilot ? 'link' : 'email';
  const currentTab = inviteClientTab || defaultTab;

  if (hideEmailAndFillIntakeForm && !isEdjPilot) {
    return (
      <div className="mt-4 w-full">
        <LinkTab withHeader={false} />
      </div>
    );
  }

  return (
    <Tabs
      value={isEdjPilot && currentTab !== 'link' ? 'link' : currentTab}
      onValueChange={value => setInviteClientTab(value as TabType)}
      className="w-full"
    >
      <TabsList className="w-full">
        <EdjPilotRestricted>
          <TabsTrigger
            value="email"
            className="flex-1 gap-2"
          >
            <Mail className="hidden size-4 sm:block" />
            Invite via Email
          </TabsTrigger>
        </EdjPilotRestricted>
        <TabsTrigger
          value="link"
          className="flex-1 gap-2"
        >
          <Link2 className="hidden size-4 sm:block" />
          Share via link
        </TabsTrigger>
        <EdjPilotRestricted>
          <TabsTrigger
            value="fill-form"
            className="flex-1 gap-2"
          >
            <ClipboardPen className="hidden size-4 sm:block" />
            Fill Intake Form
          </TabsTrigger>
        </EdjPilotRestricted>
      </TabsList>
      <TabsContent
        value="email"
        className="mt-4"
      >
        <EmailTab />
      </TabsContent>
      <TabsContent
        value="link"
        className="mt-4"
      >
        <LinkTab />
      </TabsContent>
      <TabsContent
        value="fill-form"
        className="mt-4"
      >
        <FillIntakeFormTab />
      </TabsContent>
    </Tabs>
  );
}
